import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type VerticalType,
  type VerticalConfig,
} from '@constants/verticalConstants';
import { activeVertical, verticalConfig } from '@config/verticalEnv';
import { verticalConfigs } from '@config/verticals';

export interface VerticalState {
  vertical: VerticalType;
  config: VerticalConfig;
  isInitialized: boolean;
}

const initialState: VerticalState = {
  vertical: activeVertical,
  config: verticalConfig,
  isInitialized: true,
};

const verticalSlice = createSlice({
  name: 'vertical',
  initialState,
  reducers: {
    setVertical: (state, action: PayloadAction<VerticalType>) => {
      state.vertical = action.payload;
      state.config = verticalConfigs[action.payload];
      state.isInitialized = true;
    },
  },
});

export const { setVertical } = verticalSlice.actions;
export default verticalSlice.reducer;
